import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { FiArrowLeft, FiEdit } from 'react-icons/fi';

const EmployeeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const res = await api.get(`/employees/${id}`);
        setEmployee(res.data);
      } catch (err) {
        toast.error('Failed to load employee');
        navigate('/employees');
      } finally {
        setLoading(false);
      }
    };
    fetchEmployee();
  }, [id, navigate]);

  if (loading) return <div className="loading">Loading...</div>;
  if (!employee) return null;

  const fields = [
    { label: 'Employee ID', value: employee.employeeId },
    { label: 'Name', value: employee.name },
    { label: 'Email', value: employee.email },
    { label: 'Phone', value: employee.phone },
    { label: 'Department', value: employee.department?.name || 'N/A' },
    { label: 'Designation', value: employee.designation },
    { label: 'Joining Date', value: new Date(employee.joiningDate).toLocaleDateString() },
    { label: 'Salary', value: `$${employee.salary?.toLocaleString()}` },
    { label: 'Status', value: employee.status },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Employee Details</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn-secondary" onClick={() => navigate('/employees')}><FiArrowLeft /> Back</button>
          {(user.role === 'admin' || user.role === 'hr') && (
            <Link to={`/employees/${id}/edit`} className="btn-primary"><FiEdit /> Edit</Link>
          )}
        </div>
      </div>
      <div className="detail-card">
        <div className="detail-grid">
          {fields.map(f => (
            <div key={f.label} className="detail-item">
              <label>{f.label}</label>
              <span>{f.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetail;
